import { z } from "zod";
import { Sha256HexSchema } from "./primitives.js";

export const AttackCategorySchema = z.enum([
  "direct_injection",
  "indirect_injection",
  "tool_poisoning",
  "tool_poisoning_full_schema",
  "tool_poisoning_unicode_tag",
  "cross_server_shadowing",
  "rug_pull",
  "secret_exfiltration",
  "cross_tenant_leak",
  "multi_step_chain_abuse",
  "intent_flow_subversion",
  "oauth_token_passthrough",
  "dns_rebinding",
  "command_injection",
  "path_traversal",
  "ssrf",
  "ansi_escape_injection",
  "cross_resource_exfil_chain"
]);
export type AttackCategory = z.infer<typeof AttackCategorySchema>;

/** OWASP LLM Top 10 tag, e.g. "LLM01:2025" (Prompt Injection). */
export const OwaspLlmTagSchema = z.string().regex(/^LLM\d{2}(:\d{4})?$/);
/** OWASP MCP Top 10 tag, e.g. "MCP01". */
export const OwaspMcpTagSchema = z.string().regex(/^MCP\d{2}$/);
/** MITRE ATLAS technique id, e.g. "AML.T0051". */
export const MitreAtlasTagSchema = z.string().regex(/^AML\.[A-Z]+\d{4}(\.\d{3})?$/);

export const AttackFindingSchema = z.object({
  id: z.string().min(1),
  category: AttackCategorySchema,
  description: z.string().min(1),
  /** Did the harmful action *execute*? Pattern-matched detection is not enough. */
  exploitConfirmed: z.boolean(),
  evidence: z.string().min(1),
  owaspLlm: z.array(OwaspLlmTagSchema).default([]),
  owaspMcp: z.array(OwaspMcpTagSchema).default([]),
  mitreAtlas: z.array(MitreAtlasTagSchema).default([]),
  regressionTestPath: z.string().optional()
});
export type AttackFinding = z.infer<typeof AttackFindingSchema>;

export const RedteamReportSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  serverDigest: Sha256HexSchema,
  serverKind: z.enum(["designed", "naive-baseline"]),
  findings: z.array(AttackFindingSchema),
  summary: z.object({
    attempted: z.number().int().nonnegative(),
    confirmed: z.number().int().nonnegative(),
    blocked: z.number().int().nonnegative()
  }),
  generatedAt: z.string().datetime({ offset: true })
});
export type RedteamReport = z.infer<typeof RedteamReportSchema>;
